import { useState } from 'react';

interface SearchFiltersProps {
  onSearch: (filters: any) => void;
  tenants: Array<{ id: string; name: string }>;
  venues: Array<{ id: string; name: string; tenantId: string }>;
}

export default function SearchFilters({ onSearch, tenants, venues }: SearchFiltersProps) {
  const [searchType, setSearchType] = useState('mac');
  const [searchValue, setSearchValue] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedVenue, setSelectedVenue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const filteredVenues = selectedTenant 
    ? venues.filter(v => v.tenantId === selectedTenant)
    : venues;

  const handleSearch = () => {
    onSearch({
      searchType,
      searchValue,
      tenant: selectedTenant,
      venue: selectedVenue,
      status: selectedStatus,
      startDate,
      endDate
    });
  };

  const handleReset = () => {
    setSearchType('mac');
    setSearchValue('');
    setSelectedTenant('');
    setSelectedVenue('');
    setSelectedStatus('');
    setStartDate('');
    setEndDate('');
    onSearch({});
  };

  return (
    <div className="bg-white rounded-lg p-4 mb-4">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">搜索类型</label>
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="mac">MAC地址</option>
            <option value="name">名称</option>
            <option value="sn">序列号SN</option>
            <option value="id">ID</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">搜索内容</label>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={`请输入${
              searchType === 'mac' ? 'MAC地址' : 
              searchType === 'name' ? '名称' : 
              searchType === 'sn' ? '序列号' : 'ID'
            }`}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">租户</label>
          <select
            value={selectedTenant}
            onChange={(e) => {
              setSelectedTenant(e.target.value);
              setSelectedVenue('');
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">全部租户</option>
            {tenants.map(tenant => (
              <option key={tenant.id} value={tenant.id}>{tenant.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">场所</label>
          <select
            value={selectedVenue}
            onChange={(e) => setSelectedVenue(e.target.value)}
            disabled={!selectedTenant}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-100"
          >
            <option value="">全部场所</option>
            {filteredVenues.map(venue => (
              <option key={venue.id} value={venue.id}>{venue.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">状态</label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="">全部状态</option>
            <option value="enabled">启用</option>
            <option value="disabled">停用</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">创建开始时间</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">创建结束时间</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div className="flex items-end gap-2">
          <button
            onClick={handleSearch}
            className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
          >
            搜索
          </button>
          <button
            onClick={handleReset}
            className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap"
          >
            重置
          </button>
        </div>
      </div>
    </div>
  );
}
